import { Link } from "react-router";
import { Icone } from "../componentes/Icone.js";
import { IconeCriar } from "../componentes/icones.js";
import type { Trilha } from "@noesis/shared";
import { useTour } from "../estado/tour.js";

/**
 * "Nenhuma trilha selecionada" — RN-04.
 *
 * É **tela guiada, não erro**. Nada aqui usa `role="alert"`, cor de erro ou
 * frase de falha: não deu errado nada, o usuário só ainda não tem onde
 * estudar. O que a tela deve a ele é dizer o que fazer agora, e ter o botão
 * que faz.
 *
 * Dois casos diferentes, e a diferença importa:
 *  · nenhuma trilha existe — conta nova, ou acabou de excluir a última;
 *  · existem trilhas, todas arquivadas — desarquivar é mais perto do que criar.
 */
export function SemTrilha({ trilhas }: { trilhas: Trilha[] }) {
  const todasArquivadas = trilhas.length > 0;
  const tour = useTour();

  return (
    <section className="estado" aria-labelledby="sem-trilha-titulo">
      <h2 className="estado__titulo" id="sem-trilha-titulo">
        {todasArquivadas ? "Nenhuma trilha em uso" : "Nenhuma trilha ainda"}
      </h2>

      {todasArquivadas ? (
        <>
          <p className="estado__texto">
            Suas {trilhas.length === 1 ? "trilha está arquivada" : `${trilhas.length} trilhas estão arquivadas`}.
            Arquivar tira da circulação sem apagar nada: os itens, as respostas e o caderno continuam lá.
          </p>
          <p className="estado__texto">
            Desarquive uma para voltar a estudar, ou comece uma frente nova.
          </p>
          <Link className="botao" to="/trilhas">
            Ver trilhas arquivadas
          </Link>
          <Link className="botao botao--texto" to="/trilhas/nova">
            Criar outra trilha
          </Link>
        </>
      ) : (
        <>
          <p className="estado__texto">
            Uma trilha é a frente que você está estudando — uma disciplina, uma linguagem, um concurso. Tudo no
            Grifo é separado por ela: itens, respostas, metas, caderno e estatísticas.
          </p>
          <p className="estado__texto">
            Crie a primeira para começar a importar itens. Dá para ter quantas quiser e trocar quando quiser.
          </p>
          <Link className="botao" to="/trilhas/nova" data-tour="criar" onClick={() => tour.avancarSe("criar")}>
            <Icone glifo={IconeCriar} papel="acao" />
            Criar trilha
          </Link>
        </>
      )}
    </section>
  );
}
